<script>
export default {
  data() {
    return {
      data: {
        id: 1,
        title: "【央视快评】推动我国人工智能朝着有益、安全、公平方向健康有序发展",
        uesrName: "央视网",
        date: " 2025年04月26日 16:09",
        viewcount: 222,
        content:
          '<div class="text_area" id="text_area" style="display: block;"><div class="ELMTEE3E2ZOVMguxTEryEyzq210325" data-spm="EEE3E2ZOVMgu"></div><p style="text-indent: 2em;">“面对新一代人工智能技术快速演进的新形势，要充分发挥新型举国体制优势，坚持自立自强，突出应用导向，推动我国人工智能朝着有益、安全、公平方向健康有序发展。”4月25日，中共中央政治局就加强人工智能发展和监管进行第二十次集体学习。习近平总书记主持学习并发表重要讲话。</p><p style="text-indent: 2em;">习近平总书记的重要讲话，精准把握时代脉搏和世界科技发展大势，高度统筹中国发展和全人类福祉，围绕我国发展人工智能的战略意义、主攻方向、重点任务、价值取向等一系列重大问题进行了深刻阐述，为我国人工智能发展指明了前进方向。</p><p style="text-align: center;" class="photo_img_20190808"><img src="//p5.img.cctvpic.com/photoworkspace/contentimg/2025/04/26/2025042615564191674.jpg" alt=""></p><p style="text-indent: 2em;">今年以来，我国人工智能领域亮点频出、成果丰硕。从总台春晚舞台上的“赛博秧歌”，到总台参与联合主办的全球首个人形机器人半程马拉松开跑，各类机器人走出实验室，技术能力加速迭代，应用场景不断拓展。国产大模型DeepSeek引发落地应用热潮，算法的优化进一步降低成本，大模型走入寻常百姓家，AI成为许多人工作、学习和生活的“搭子”……这正是我国人工智能综合实力实现整体性、系统性跃升的真实写照。</p><p style="text-indent: 2em;">人工智能是新一轮科技革命和产业变革的重要驱动力量。特别是在当前科技革命与大国博弈相互交织的形势下，我们要在危机中育新机，于变局中开新局，以高质量发展的确定性应对外部环境急剧变化的不确定性，人工智能是极其重要的抓手和着力点。我们必须抢抓人工智能发展的历史性机遇，推动经济社会高质量发展。</p><p style="text-align: center;" class="photo_img_20190808"><img src="//p1.img.cctvpic.com/photoworkspace/contentimg/2025/04/26/2025042615570488222.jpg" alt=""></p><p style="text-indent: 2em;">科技是第一生产力。世界知识产权组织报告显示，我国已成为全球人工智能专利最大拥有国，占比达60%。同时也要看到，我国在基础理论、关键核心技术等方面还存在短板弱项，要正视差距、加倍努力，发挥新型举国体制优势，全面推进人工智能科技创新、产业发展和赋能应用。一方面，在基础理论、方法、工具等方面取得突破，构建自主可控、协同运行的人工智能基础软硬件系统；另一方面，推动人工智能科技创新与产业创新深度融合，构建企业主导的产学研用协同创新体系，助力传统产业改造升级，开辟战略性新兴产业和未来产业发展新赛道。</p><p style="text-indent: 2em;">推动人工智能发展是一项关乎全人类未来的复杂系统工程。这要求我们要有系统观念、前瞻思维、国际视野、天下情怀。要提供有力的政策支持，综合运用知识产权、财政税收、政府采购、设施开放等政策，做好科技金融文章，推动人工智能发展。要健全人工智能监管体制机制，在发展与治理中牢牢掌握主动权。要广泛开展人工智能国际合作，为弥合全球智能鸿沟作出中国贡献。</p><p style="text-align: center;" class="photo_img_20190808"><img src="//p4.img.cctvpic.com/photoworkspace/contentimg/2025/04/26/2025042615572247932.jpg" alt=""></p><p style="text-indent: 2em;">得时无怠、只争朝夕。我们要深入贯彻落实习近平总书记关于发展人工智能的一系列重要讲话指示批示精神，增强紧迫感，加快行动步伐，加快实施“人工智能+”行动，加快赋能千行百业，充分发挥人工智能溢出带动性强的“头雁”效应，乘势而上、行稳致远，推动人工智能健康有序发展，为以中国式现代化全面推进强国建设、民族复兴伟业注入强大科技创新动力。</p><div class="ystg_ind_08"><p>央视评论员</p></div>	</div>',
      },
    };
  },
};
</script>
<template>
  <div class="detail_banner">
    <div class="banner_item">
      <img src="../../assets/new1.jpg" />
    </div>
  </div>
  <div class="contaier content">
    <div class="inner">
      <div class="news_detail_title">{{ data.title }}</div>
      <div style="height: 1px; background: #f8f8f8"></div>
      <div class="news_detail_filed">
        <span class="news_detail_date">发布时间：{{ data.date }}</span>
        <span class="news_detail_date">文字来源：{{ data.uesrName }}</span>
        <span class="news_detail_date">点击率：{{ data.viewcount }} 次</span>
      </div>
      <div class="news_detail_content" v-html="data.content"></div>
    </div>
  </div>
</template>

<script></script>

<style>
.detail_banner {
  height: 400px;
}
.detail_banner img {
  width: 100%;
  height: 440px;
}
.news_detail_title {
  height: 45px;
  line-height: 45px;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}
.news_detail_filed {
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  text-align: center;
  color: #999;
}
.news_detail_content {
  padding: 10px;
  color: #666;
}
.news_detail_date {
  margin-left: 80px;
  margin-right: 80px;
}
</style>
